import { CheckOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import React from 'react';
import { truncateString } from "utils/chatUtils";
import MessageTypeBody from "components/Dashboard/MessageTypes/MessageBodies";

const URL_REGEX = /(https?:\/\/[^\s]+)/g;

const renderTextWithLinks = (text: string): React.ReactNode => {
    if (!text) return text;
    return text.split(URL_REGEX).map((part, index) =>
        /^https?:\/\//.test(part) ? (
            <a
                key={index}
                href={part}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
            >
                {part}
            </a>
        ) : (
            part
        )
    );
};

const MessageBox: React.FC<{
    message: MessageObj;
    truncateLength?: number,
    hideCheck?:boolean,
    /** Opens the message in its own view — MessageItem passes handleIconClick. */
    onOpen?: (message: MessageObj) => void

}> = ({
    message,
    truncateLength,
    hideCheck,
    onOpen
}) => {

        return (
            <div>
                <Row>
                    <Col span={22}>
                        <p title={truncateLength?message.message:""} style={{color:"black"}}>
                            {truncateLength?truncateString(message.message, 150):renderTextWithLinks(message.message)}{" "}
                            {/* {
                                message.data?.responseAnswers?.[localStorage.getItem("RID")]
                            } */}
                        </p>
                    </Col>
                </Row>
                {!hideCheck && localStorage.getItem("RID") === message.senderId.toString() && (
                        <Col
                            span={2}
                            className="d-flex justify-content-end align-items-start pull-right"
                        >
                            <CheckOutlined style={{ color: "rgb(70 130 244)" }} />
                        </Col>
                    )}
                {/* Rich per-type bodies. Skipped in truncated mode: the forward
                    popup shows a one-line preview, not a full card. */}
                {!truncateLength && (
                    <MessageTypeBody message={message} onOpen={onOpen} />
                )}
            </div>
        );
    }

export default MessageBox;
